import { useEffect, useRef, useState } from "react";

const SCRIPT_ID = "cloudflare-turnstile-script";

export default function TurnstileWidget({ onToken, onExpired, onError }) {
  const container = useRef(null);
  const [ready, setReady] = useState(false);
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;

  useEffect(() => {
    if (!siteKey || !container.current) return undefined;
    const render = () => {
      if (!window.turnstile || !container.current) return;
      window.turnstile.render(container.current, {
        sitekey: siteKey,
        theme: "dark",
        callback: (token) => { onToken(token); setReady(true); },
        "expired-callback": () => { onExpired(); setReady(false); },
        "error-callback": () => { onError(); setReady(false); },
      });
    };
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      existing.addEventListener("load", render);
      if (window.turnstile) render();
      return () => existing.removeEventListener("load", render);
    }
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    script.addEventListener("load", render);
    document.head.appendChild(script);
    return () => script.removeEventListener("load", render);
  }, [siteKey, onToken, onExpired, onError]);

  if (!siteKey) return <p data-testid="turnstile-configuration-message" className="text-sm text-latte">Submissions are temporarily unavailable while protection is being configured.</p>;
  return <div data-testid="turnstile-widget" ref={container} aria-label="Submission protection" className={ready ? "" : "min-h-[65px]"} />;
}